module.exports = "<div>\n    <ngx-spinner bdOpacity=0.9 size=\"medium\" color=\"#F5A623\" type=\"square-loader\" [fullScreen]=\"true\"></ngx-spinner>\n</div>"